export default "__VITE_ASSET__0ad0d5d0__"